import React, { useEffect, useState } from 'react';
import Chart from 'react-apexcharts';
import { useSelector } from 'react-redux';


const ExchangenormaltradeChart = ({ dates }) => {

  const theme = useSelector((state) => state.theme.theme);

  const [options,setOption] = useState({
    chart: {
      type: 'area',
      stacked: false,
      height: 350,
      zoom: {
        type: 'x',
        enabled: true,
        autoScaleYaxis: true,
      },
      toolbar: {
        autoSelected: 'zoom',
      },
    },
    // yaxis: {
    //   opposite: true, // Move Y-axis labels to the right
    // },
    dataLabels: {
      enabled: false,
    },
    markers: {
      size: 0,
    },
    title: {
      // text: 'Price Movement',
      align: 'left',
    },
    fill: {
        colors: ["#00A83E"],
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.5,
        opacityTo: 0,
        stops: [0, 90, 100],
      },
    },
    yaxis: [
      {
        opposite: true, // Position Y-axis labels on the right
        title: {
          // text: "Price", // Optional: Add a title to the Y-axis
          style: {
            color: (theme === "dark" ? "#fff":"#000"),
            fontSize: "12px",
          },
        },
        labels: {
          formatter: (val) => (val / 1000000).toFixed(0),
          style: {
            colors: (theme === "dark" ? "#fff":"#000"), // Change X-axis label color
            fontSize: "12px", // Adjust font size  
          },
        },
        
      },
      
    ],
    xaxis: {
      type: 'datetime',
      labels: {
        style: {
          colors: (theme === "dark" ? "#fff":"#000"), // Change X-axis label color
          fontSize: "12px", // Adjust font size
        },
      },
    },
    tooltip: {
      custom: function({series, seriesIndex, dataPointIndex, w}) {
        return  '<ul style="padding-left:0px;margin-bottom:0px;">' +
        '<li style="margin-bottom:8px;"><b>Price</b> : ' + series[seriesIndex][dataPointIndex]+ '</li>' +
        '<li><b>Vol 24h</b> : ' + series[seriesIndex][dataPointIndex] + '</li>' +
        '</ul>';
      }
    },
    // tooltip: {
    //   shared: false,
    //   x: {
    //     show: false,
    //  },
    //   y: {
    //     formatter: (val) => (val / 1000000).toFixed(0),
    //   },
    // },
  });


  const [refresh,setRefresh] = useState(true);

  useEffect(()=>{
    let instoptions = options;
    console.log('themethemeCHARTTT',theme)
    instoptions.yaxis[0].title.style.color = (theme === "dark" ? "#fff":"#000");
    instoptions.yaxis[0].labels.style.colors = (theme === "dark" ? "#fff":"#000");
    instoptions.xaxis.labels.style.colors = (theme === "dark" ? "#fff":"#000");
    setRefresh(false)
    setOption({
      ...instoptions
    })
    setTimeout(()=>{
      setRefresh(true)
    },[1])
  }, [theme]);

  console.log('optionsoptions',options)

  const series = [
    {
      name: 'Listing Platforms',
      data: dates,
    },
  ];

  return (
    <div id="chart" className='chart_exchange py-3'>
      {
        refresh
        ?
        <Chart options={options} series={series} type="area" height={350} />
        :
        <></>
      }
      
    </div>
  );
};

export default ExchangenormaltradeChart;
